import { FaqAccordion } from "@cinch-nx/landing-ui-shared";
import { FeatureSection } from "@cinch-nx/landing-ui-shared";
import { ImageObject } from "@cinch-nx/landing-ui-shared";
import { RichTextSection } from "@cinch-nx/landing-ui-shared";
import { Video } from "@cinch-nx/landing-ui-shared";
import { LatestCarsSection, LinksSection, SEOTable, TextInlineImage } from "../components";
export var storyblokComponents = {
    FaqSection: FaqAccordion,
    YoutubeVideo: Video,
    LatestCarsSection: LatestCarsSection,
    RichTextSection: RichTextSection,
    FeatureSection: FeatureSection,
    LinksSection: LinksSection,
    TextInlineImage: TextInlineImage,
    Image: ImageObject,
    TableSection: SEOTable
};
